import { Calendar } from 'primereact/calendar'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { OutlinedBtnPrimary, SectionTitle } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import './RevisaoDataProgramacao.css'
import useRevisaoDataProgramacaoState from './RevisaoDataProgramacaoState'

export default connect()(RevisaoDataProgramacao)

function RevisaoDataProgramacao({ ciclo, dispatch }) {
  const { state, localDispatcher } = useRevisaoDataProgramacaoState()

  useEffect(() => {
    localDispatcher.fetchProgramacao(ciclo)
  }, [])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatcher.resetMessages()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatcher.resetMessages()
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.loadingMessage) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . . '))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  // Render
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Revisão da Data Programada para Recebimento da Carga" />
      </div>
      <div className="p-col-12">
        <OutlinedBtnPrimary
          label="Salvar"
          onClick={() => localDispatcher.onSalvar(state.programacao)}
        />
      </div>
      <div className="p-col-12">
        <DataTable
          value={state.programacao}
          emptyMessage="Nenhuma Data de Programação encontrada. Verifique que os trechos estão definidos"
          rows={10}
          paginator
        >
          <Column
            field="data_programacao"
            header="Data de Programação"
            style={tableCellCentered(200)}
            body={item => (
              <Calendar
                className="RevisaoDataProgramacao"
                dateFormat="dd/mm/yy"
                value={
                  typeof item.data_programacao === 'string'
                    ? new Date(item.data_programacao)
                    : item.data_programacao
                }
                onChange={e => localDispatcher.onDataProgramacaoChange(e.value, item)}
              />
            )}
          />
          <Column field="tp_nome" header="Operação Logística" />
          <Column field="step" header="Trecho" style={tableCellCentered()} />
          <Column field="qte_deliveries" header="Qte Entregas" style={tableCellCentered(120)} />
          <Column field="qte_caixas" header="Qte Caixas" style={tableCellCentered()} />
        </DataTable>
      </div>
    </div>
  )
}
